import { useEffect, useMemo } from 'react'
import './PaintSplashBurst.css'

export function PaintSplashBurst({ x, y, color = '#3b82f6', onDone }) {
  useEffect(() => {
    const t = setTimeout(() => onDone?.(), 750)
    return () => clearTimeout(t)
  }, [onDone])

  const n = 18
  const drops = useMemo(
    () =>
      Array.from({ length: n }, (_, i) => ({
        angle: (i / n) * 360 + (Math.random() - 0.5) * 28,
        dist: 36 + Math.random() * 52,
      })),
    [],
  )

  return (
    <div
      className="paint-splash-burst"
      style={{ left: x, top: y }}
      role="presentation"
      aria-hidden
    >
      {drops.map((d, i) => (
        <span
          key={i}
          className="paint-splash-drop"
          style={{
            '--splash-angle': `${d.angle}deg`,
            '--splash-dist': `${d.dist}px`,
            '--splash-color': color,
            '--splash-delay': `${i * 18}ms`,
          }}
        />
      ))}
    </div>
  )
}
